import React, { useState, useCallback } from 'react';
import { Outlet } from 'react-router-dom';
import Header from './Header';
import Sidebar from './Sidebar';
import { useAuth } from '../../context/AuthContext';
import '../../styles/layout.css';

const Layout = () => {
  const { user } = useAuth();
  const isSuperAdmin = user?.role === 'Super Admin';
  const [isMobileSidebarOpen, setIsMobileSidebarOpen] = useState(false);

  const toggleSidebar = useCallback(() => {
    setIsMobileSidebarOpen((open) => !open);
  }, []);

  return (
    <div className={`app ${isMobileSidebarOpen ? 'drawer-open' : ''}`}>
      <Sidebar
        isSuperAdmin={isSuperAdmin}
        isOpen={isMobileSidebarOpen}
        setIsOpen={setIsMobileSidebarOpen}
      />
      <div className="main-content">
        <Header toggleSidebar={toggleSidebar} />
        <main className="content">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default Layout;
